<div class="container-list-columns" [style]="'grid-template-columns: ' + gridColumnsWidths">
  <ng-content></ng-content>
</div>
